import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

// On slideChange: pause all videos in the swiper (and reset them to 0 for
// cleanliness), then if the new active slide contains a <video>, play it
// muted. The video keeps its controls so the user can unmute / pause.
function handleVideosOnSlideChange(swiper) {
        if (!swiper || !swiper.el) return;
        var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
        swiper.el.querySelectorAll('video').forEach(function (v) {
                var isActive = activeSlide && activeSlide.contains(v);
                if (!isActive) {
                        try { v.pause(); v.currentTime = 0; } catch (e) { /* noop */ }
                }
        });
        if (activeSlide) {
                var activeVideo = activeSlide.querySelector('video');
                if (activeVideo) {
                        activeVideo.muted = true;
                        var p = activeVideo.play();
                        if (p && typeof p.catch === 'function') { p.catch(function () { /* autoplay rejected — fine */ }); }
                }
        }
}

export default function singleProductSwiper() {
        // Initialize the thumbs gallery
        var galleryThumbs = new Swiper('.gallery__thumbs', {
            spaceBetween: 24,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        // Initialize the main gallery
        var galleryTop = new Swiper('.gallery__slider', {
            speed: 300,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoHeight: true,
            thumbs: {
                swiper: galleryThumbs,
            },
            breakpoints: {
                400: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 'auto',
                },
            },
        });

        if (galleryTop && typeof galleryTop.on === 'function') {
            galleryTop.on('slideChange', function () { handleVideosOnSlideChange(galleryTop); });
        }

        // Shop product page gallery
        if (document.querySelector('.shop-product__slider')) {
            var shopThumbs = new Swiper('.shop-product__thumbs', {
                spaceBetween: 12,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });

            var shopGallery = new Swiper('.shop-product__slider', {
                speed: 300,
                spaceBetween: 0,
                autoHeight: true,
                thumbs: {
                    swiper: shopThumbs,
                },
            });

            if (shopGallery && typeof shopGallery.on === 'function') {
                shopGallery.on('slideChange', function () { handleVideosOnSlideChange(shopGallery); });
            }
        }
}
